import React from "react";
import {Button} from "reactstrap";

export class ColorFormatter extends React.Component {
    render() {
        return (
            <div className={"colorFormatter"}>
                <Button style={{backgroundColor: `${this.props.color}`, width: "16px", height: "16px", margin: "5px"}} disabled={true}/>
                <label> {`${this.props.color}`}  </label>
            </div>
        );
    }
}